import Repository from '../Repository';

const url = '/subscription/start';

export default {
    getStep(payload) {
        return Repository.get(`${url}/step`);
    },

    createAddress(payload) {
        return Repository.post(`${url}/create-address`, payload);
    },

    answerQuestions(payload) {
        return Repository.post(`${url}/answer-questions`, payload);
    },

    /*
        STRIPE
     */

    redeemCoupon(couponCode) {
        return Repository.get(`${url}/coupon/redeem?couponCode=${couponCode}`,{localLoading: true});
    },
    validatePartnerCode(partnerCode) {
        return Repository.get(`${url}/partner-code/validate?partnerCode=${partnerCode}`,{localLoading: true});
    },
    createSetupIntent() {
        return Repository.get(`${url}/setup-intent`);
    },
    subscribe(pmId, couponCode = '', partnerCode = '') {
        let data = {pm_identifier: pmId};

        if(couponCode !== '') {
            data.couponCode = couponCode;
        }

        if(partnerCode !== '') {
            data.partnerCode = partnerCode;
        }

        return Repository.post(`${url}/subscribe`, data)
    },

    updateCard(pmId){
        let data = {pm_identifier: pmId};

        return Repository.post(`${url}/update`, data)

    }
}
